import { NgModule, SkipSelf, Optional, Provider, ModuleWithProviders } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CORE_CONFIG } from './environment';

export interface MrrsCoreModuleOptions {
  optionsProvider?: Provider;
  config?: {
    endpoint?: string;
    token?: string;
  };
}

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  declarations: [
  ],
  exports: [
  ]
})
export class MrrsCoreModule {

  constructor(@Optional() @SkipSelf() parentModule: MrrsCoreModule) {
    if (parentModule) {
      throw new Error('MrrsCoreModule is already loaded. It should only be imported in your application\'s main module.');
    }
  }

  static forRoot(options: MrrsCoreModuleOptions): ModuleWithProviders {
    return {
      ngModule: MrrsCoreModule,
      providers: [
        options.optionsProvider || {
          provide: CORE_CONFIG,
          useValue: options.config
        }
      ]
    };
  }
}
